import HomeIcon from 'assets/icons/menu/home.svg';
import BookingsIcon from 'assets/icons/menu/bookings.svg';
import ReportsIcon from 'assets/icons/menu/reports.svg';
import { ROUTES } from 'core/routing/routes';

export const sections = [
    {
        title: 'Menu',
        items: [
            {
                label: 'layout.menu.home',
                path: ROUTES.HOME,
                icon: HomeIcon,
            },
            {
                label: 'layout.menu.mybookings',
                path: ROUTES.BOOKINGS,
                icon: BookingsIcon,
            },
            {
                label: 'layout.menu.reports',
                path: ROUTES.REPORTS,
                icon: ReportsIcon,
            },
        ],
    },
];
